class SerializrType_UTCdate {
    serializer({ value }) {
        if (value === null || value === undefined)
            return value;
        if (value instanceof Date) {
            return value.mysqlUTCTimestamp;
        }
        console.error('Error in Date serialization, value is no Date object', value);
        return undefined;
    }
    deserializer({ json: dateString }) {
        if (dateString === null || dateString === undefined)
            return dateString;
        return dateString.dateFromMysqlUTCTimestamp;
    }
}
const obj = new SerializrType_UTCdate();
export function UTCdate() {
    return obj;
}
